import { render, staticRenderFns } from "./ResultsLists.vue?vue&type=template&id=2cd7e718&"
import script from "./ResultsLists.vue?vue&type=script&lang=js&"
export * from "./ResultsLists.vue?vue&type=script&lang=js&"
import style0 from "./ResultsLists.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports